import state from './ekioskReportState'
import mutations from './ekioskReportMutations'
import actions from './ekioskReportActions'
import getters from './ekioskReportGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
